import { colors } from '@creditornot/cb-ingredients';
import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

import { typographyCss } from 'common/typography';

type Props = {
  link: string;
  linkLabel: React.ReactNode;
  message: React.ReactNode;
};

const LinkContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
`;

const StyledLink = styled(Link)`
  ${typographyCss.Body3};
  font-weight: 500;
  margin-block-start: 8px;
  margin-inline-end: 16px;
  color: ${colors.wolt100};

  &:hover {
    color: ${colors.wolt92};
  }
`;

export const SuccessToast = ({ link, linkLabel, message }: Props) => {
  return (
    <div>
      {message}
      <LinkContainer>
        <StyledLink to={link}>{linkLabel}</StyledLink>
      </LinkContainer>
    </div>
  );
};
